// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--AQlWu","text":"a10a3f92e9--text--k70Kd","link":"a10a3f92e9--link--xphTL"};